export function prefixLegend(component: string | null | undefined): string {
  return (component) ? `${component}-` : ''
}

export function suffixLegend(index: number | string | null | undefined, sub_index?: number | string | null | undefined): string {
  return (index !== null && index !== undefined) ? `-${index}${(sub_index !== null && sub_index !== undefined) ? `-${sub_index}` : ''}` : ''
}
